@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import 'variables';

.accountBox {
  border: solid $border-width $divider-color;
  border-radius: $border-radius-md;
}

.googleIconContainer {
  width: $spacer * 1.625;
  height: $spacer * 1.625;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $border-radius-xs;
  background: $white;
  margin-right: $spacer * 0.625;

  .googleIcon {
    width: $icon-size-base;
    height: $icon-size-base;
  }
}

.googleAuthContainer {
  height: $spacer * 1.75;
  padding: 1px;
  display: flex;
  align-items: center;
  background: $google-btn-bg;
  border-radius: $border-radius-xs;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.17), 0 0 1px 0 rgba(0, 0, 0, 0.08);
}
